import { useTranslations } from '@/hooks/use-translations';
import { AssetViewer } from '@/modules/asset-viewer';
import { AnamneseCard } from '@/modules/case/components/AnamneseCard';
import { Asset, AnamneseItem } from '@/modules/case/types';

interface AnamesePanelProps {
  isOpen: boolean;
  onClose: () => void;
  anamneseData: AnamneseItem | null;
  allAssets: Asset[];
  assetsBaseUrl: string;
}

export const AnamnesePanel = ({
  isOpen,
  onClose,
  anamneseData,
  allAssets,
  assetsBaseUrl,
}: AnamesePanelProps) => {
  const { t } = useTranslations();

  if (!anamneseData) return null;

  // Otherwise, display the anamnese as custom content in AssetViewer
  return (
    <AssetViewer
      isOpen={isOpen}
      onClose={onClose}
      assets={[]}
      assetsBaseUrl={assetsBaseUrl}
      initialIndex={0}
      title={t('caseViewer.navigation.patientInfo')}
      customContent={
        <AnamneseCard
          variant="modal"
          gender={anamneseData.gender}
          title={anamneseData.title}
          descriptionList={anamneseData.descriptionList}
        />
      }
    />
  );
};
